import { actionType } from './actions';

const initialState = {
    activeItem: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_SIDEBAR_SELECTED_ITEM: {
            return {
                ...state,
                activeItem: action.payload
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/sidebar/reducers.js